module.exports = __webpack_public_path__ + "static/media/LeadingDoctors.6a056f3f.png";